import React from 'react';
import { AlertTriangleIcon, ClockIcon, ZapIcon, TrendingUpIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../utils/translations';
export function UrgencySection() {
  const {
    language
  } = useLanguage();
  const t = translations[language].urgency;
  return <section className="py-20 px-4 bg-gradient-to-b from-teal-950 to-black" data-id="element-574">
      <div className="max-w-4xl mx-auto" data-id="element-575">
        <div className="bg-gradient-to-br from-red-950/30 to-black border-2 border-red-600/50 rounded-2xl p-8 md:p-12" data-id="element-576">
          <div className="flex items-center justify-center gap-3 mb-6" data-id="element-577">
            <AlertTriangleIcon className="w-12 h-12 text-red-400" data-id="element-578" />
            <h2 className="text-3xl md:text-4xl font-bold text-red-400" data-id="element-579">
              {t.title}
            </h2>
          </div>
          <p className="text-xl text-center mb-8 text-gray-200" data-id="element-580">{t.subtitle}</p>
          <div className="space-y-4 mb-8" data-id="element-581">
            <div className="flex items-start gap-4 p-4 bg-black/50 border border-red-600/30 rounded-xl" data-id="element-582">
              <ClockIcon className="w-8 h-8 text-red-400 flex-shrink-0" data-id="element-583" />
              <p className="text-lg text-gray-200" data-id="element-584">{t.points[0]}</p>
            </div>
            <div className="flex items-start gap-4 p-4 bg-black/50 border border-red-600/30 rounded-xl" data-id="element-585">
              <ZapIcon className="w-8 h-8 text-red-400 flex-shrink-0" data-id="element-586" />
              <p className="text-lg text-gray-200" data-id="element-587">{t.points[1]}</p>
            </div>
            <div className="flex items-start gap-4 p-4 bg-black/50 border border-red-600/30 rounded-xl" data-id="element-588">
              <TrendingUpIcon className="w-8 h-8 text-red-400 flex-shrink-0" data-id="element-589" />
              <p className="text-lg text-gray-200" data-id="element-590">{t.points[2]}</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}